import { useContext } from 'react';
import { AuthContext } from '@/shared/providers/bff-auth-provider';

export const useBFFAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useBFFAuth must be used within BFFAuthProvider');
  }
  return context;
};

